import { render, staticRenderFns } from "./Cleaners.vue?vue&type=template&id=a5364786&scoped=true&lang=pug"
import script from "./Cleaners.vue?vue&type=script&lang=js"
export * from "./Cleaners.vue?vue&type=script&lang=js"
import style0 from "./Cleaners.vue?vue&type=style&index=0&id=a5364786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5364786",
  null
  
)

export default component.exports